import { AuthStatus } from '@interfaces/auth-status.model';
import { createAction, props } from '@ngrx/store';

export const getAuthStatus = createAction('[Auth Status] Get Auth Status');

export const setAuthStatus = createAction(
  '[Auth Status] Set Auth Status',
  props<{ auth: AuthStatus }>()
);
